<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <div class="relative">
      <input 
        :id="id" 
        ref="input" 
        v-bind="{ ...$attrs, class: null }" 
        class="form-input pr-10" 
        :class="{ error: error }" 
        :type="showPassword ? 'text' : 'password'" 
        :value="modelValue" 
        @input="$emit('update:modelValue', $event.target.value)" 
      />
      <button 
        type="button" 
        class="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700"
        @click="showPassword = !showPassword"
      >
        <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" />
      </button>
    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `password-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    modelValue: String,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      showPassword: false,
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>

<style scoped>
/* Hide native password toggle in Edge */
input::-ms-reveal,
input::-ms-clear {
  display: none;
}
</style>
